import { createSelector } from 'reselect'

export const selectBase = state => {
  return state.integrations
}

export const selectIsFullyLoaded = createSelector(
  selectBase,
  base => !!base.loaded
)

export const selectById = createSelector(selectBase, base => base.byId || {})

export const selectByProvider = createSelector(
  selectBase,
  base => base.byProvider || {}
)

export const selectList = createSelector(
  selectBase,
  selectById,
  (base, byId) => {
    if (!base.list) return []
    return base.list.map(id => byId[id])
  }
)

export const selectCurrentlyRemovedIntegrations = createSelector(
  selectBase,
  base => base.removedIntegrations
)
